import { replace, useNavigate, useSearchParams } from 'react-router-dom'
import logoImage from '../images/logo192.png'
import { useEffect, useState } from 'react'
import { onAuthStateChanged, signInWithEmailAndPassword, signOut } from 'firebase/auth'
import { auth } from '../services/Firebase'
import { useAuth } from '../hooks/AuthContext'
import { useTranslation } from 'react-i18next'
import { Bot, Crown, Database, Save, Target } from 'lucide-react'


export default function LoginPage() {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const { t } = useTranslation()

    const { authUser, authLoading } = useAuth()

    useEffect(() => {
        if (!authLoading && authUser) {
            navigate("/", { replace: true });
        }
    }, [authLoading, authUser, navigate]);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);


        if (!email) {
            setError(t('emailRequired'));
            setLoading(false)
            return;
        }

        if (!password) {
            setError(t('passwordRequired'));
            setLoading(false)
            return;
        }

        try {
            await signInWithEmailAndPassword(auth, email, password);
        } catch (error) {
            console.error(error);
            setError(t('loginFailed'));
            setLoading(false)
        }
    };


    const goToSearchPage = () => {
        navigate('/')
    }

    const goToRegistrationPage = () => {
        navigate('/registration')
    }
    return (
        // <div className='login-page'>

        <div className='login-screen'>
            <div className="header-container-login-registration">
                <div onClick={() => goToSearchPage()} className='header-left-login-registration'>
                    <img src={logoImage} alt="Logo" className="logo" />
                    <h3>Sigurica AI</h3>
                </div>
                <div className='header-right-login-registration'>
                    <p className=''>{t('noAccountLogin')} <a onClick={() => goToRegistrationPage()} href=''>{t('joinUs')}</a></p>
                </div>
            </div>
            <div className='login-left'>
                {/* <div onClick={() => goToSearchPage()} className='header-left-login'>
                    <img src={logoImage} alt="Logo" className="logo" />
                    <h3>Sigurica AI</h3>
                </div> */}
                <form onSubmit={handleLogin} className='login-card'>
                    <h3 className='login-welcome-back-title'>{t('loginPageTitle')}</h3>
                    <div className="form-group">
                        <input type="email" id="label" placeholder={t('email')} value={email} onChange={(e) => setEmail(e.target.value)} className="form-control" />
                    </div>
                    <div className="form-group">
                        <input type="password" placeholder={t('password')} id="pwd" value={password} onChange={(e) => setPassword(e.target.value)} className="form-control" />
                    </div>
                    <div className="form-group form-check m-0">
                        <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                        <label className="form-check-label ms-0">{t('rememberMe')}</label>
                    </div>
                    <button type="submit" className="btn-registration">
                        {loading ? (
                            <div className="spinner-border spinner-border-sm-custom" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        ) : (
                            t('signIn')
                        )}
                    </button>

                    {error && <p style={{ color: "red" }}>{error}</p>}
                    <div className='privacy-policy-terms-container'>
                        <a className='privacy-policy-terms-item' href="/legal/privacy_policy.html" >{t('privacyPolicy')}</a>| 
                        <a className='privacy-policy-terms-item' href="/legal/terms.html" >{t('termsOfUse')}</a>
                    </div>
                </form>
            </div>
            <div className='login-right'>
                <div className='login-privileges'>
                    <h2>{t('loginBenefitsTitle')}</h2>


                    <div className="benefits-list">
                        <div className="benefits-item">
                            <Bot className="benefit-icon" />
                            <span>{t('membershipBenefits1')}</span>
                        </div>
                        <div className="benefits-item">
                            <Database className="benefit-icon" />
                            <span>{t('membershipBenefits2')}</span>
                        </div>
                        <div className="benefits-item">
                            <Target className="benefit-icon" />
                            <span>{t('membershipBenefits3')}</span>
                        </div>
                        <div className="benefits-item">
                            <Save className="benefit-icon" />
                            <span>{t('membershipBenefits4')}</span>
                        </div>
                        <div className="benefits-item">
                            <Crown className="benefit-icon" />
                            <span>{t('membershipBenefits5')}</span>
                        </div>
                    </div>

                    <p className='membership-benefits-profesional'>{t('loginBenefits1')}</p>
                </div>
            </div>

        </div>
    )
}
